import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';

import ClubbieTable from '../../components/ClubbieTable/ClubbieTable';
import { fetchOrganisations, deleteOrganisation } from '../../redux/slices/organisationSlice';

/**
 * OrganisationsV2 - Modern JSX component with Tailwind CSS
 * Displays list of organizations with delete functionality
 * Uses ClubbieTable for data presentation
 */
const OrganisationsV2 = () => {
  const dispatch = useDispatch();
  const { organisations, loading } = useSelector((state) => state.organisation);

  useEffect(() => {
    dispatch(fetchOrganisations({}));
  }, [dispatch]);

  const handleDelete = useCallback(
    async (id) => {
      try {
        await dispatch(deleteOrganisation(id)).unwrap();
        toast.success('Organisation deleted successfully');
        await dispatch(fetchOrganisations({}));
      } catch (error) {
        toast.error('Failed to delete organisation');
      }
    },
    [dispatch]
  );

  const columns = React.useMemo(
    () => [
      {
        accessorKey: 'name',
        header: () => <span className="text-[#FEFCEB]">Name</span>,
        cell: ({ getValue }) => (
          <div className="flex items-center">
            <span className="text-[#FEFCEB]">{getValue() || 'N/A'}</span>
          </div>
        ),
      },
      {
        accessorKey: 'actions',
        header: () => <div className="text-[#FEFCEB] text-right">Actions</div>,
        cell: ({ row }) => (
          <div className="flex justify-end">
            <button
              onClick={() => {
                if (
                  window.confirm(
                    `Are you sure you want to delete ${row.original.name}?`
                  )
                ) {
                  handleDelete(row.original.id);
                }
              }}
              className="px-3 py-1.5 bg-red-600 hover:bg-red-700 text-[#FEFCEB] rounded-lg transition-colors text-sm"
            >
              Delete
            </button>
          </div>
        ),
      },
    ],
    [handleDelete]
  );

  return (
    <div className="min-h-screen bg-[#000F1F] text-[#FEFCEB]">
      <div className="max-w-[1400px] mx-auto py-6 px-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-[#FEFCEB] m-0">Organisations</h1>
        </div>
        <ClubbieTable data={organisations} columns={columns} loading={loading} pageSize={10} />
      </div>
    </div>
  );
};

export default OrganisationsV2;
